import React from "react";

export default function EconomicLoop()
{
  return (
    <section id="token_distribute" className="home-token_distribute">
      {/* <div className="cr_bg"></div> */}
      <div className="container ">
        <div className="sc-content wow fadeInUp">
          <div className="left">
            <div className="img_ bg_contain">
              <div className="img__ bg_contain"></div>
            </div>
          </div>
          <div className="right">
            <div className="block_50  "></div>
            <h3>
              Tokenomics?</h3>

            <div className="block_50  "></div>
            <div className="list_">
              <ul>
                <li>
                  <div className="list_item">
                    <span className="ic__ bg_contain"></span>
                    <span className="text">Presale : 30%</span>
                  </div>
                  <div className="list_item">
                    <span className="ic__ bg_contain"></span>
                    <span className="text">Ecosystem : 27%</span>
                  </div>
                  <div className="list_item">
                    <span className="ic__ bg_contain"></span>
                    <span className="text">Liquidity : 18%</span>
                  </div>
                  <div className="list_item">
                    <span className="ic__ bg_contain"></span>
                    <span className="text">Staking : 10%</span>
                  </div>
                  <div className="list_item">
                    <span className="ic__ bg_contain"></span>
                    <span className="text">Team Vesting : 10%</span>
                  </div>
                  <div className="list_item">
                    <span className="ic__ bg_contain"></span>
                    <span className="text">Marketing : 5%</span>
                  </div>
                </li>
              </ul>
            </div>
            <div className="block_50  "></div>
          </div>

        </div>
      </div>

    </section>
  );
}
